import { connect } from 'react-redux';
import PaymentRedsysRedirectOk from '../../components/checkout-steps/payment-redsys-redirect-ok';
import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    locale: state.locale,
    stores: state.stores.stores,
});

const mapDispatchToProps = (dispatch) => ({
    refreshOrder: () => {
        dispatch(Actions.refreshOrder());
    },
    goToNextStep: (order, locale, formData) => {
        dispatch(Actions.goToNextStep(order, locale, formData));
    },
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'complete',
        });
    },
});

const PaymentRedsysRedirectOkConnector = connect(mapStateToProps, mapDispatchToProps)(PaymentRedsysRedirectOk);

export default PaymentRedsysRedirectOkConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/payment-redsys-redirect-ok-connector.js
 **/